import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { history }  from '../routers/AppRouter';
import isEmail from 'validator/lib/isEmail';
import isEmpty from 'lodash/isEmpty';
import format from 'date-fns/format';
import { clearPicAppError } from '../actions/picapp';
// import { startGetParticipants } from '../actions/participants';
import { startAddNewParticipant } from '../actions/participants';
import { startDeleteParticipants } from '../actions/participants';
import { updateParticipants } from '../actions/participants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { HomeIcon } from './icons/HomeIcon';
// import PicContactsAutoSuggest from './PicContactsAutosuggest';
import PicPostRequest from '../apis/PicPostRequest';
import PicPutRequest from '../apis/PicPutRequest';
import getParticipants from '../apis/participant/getParticipants';
// import { upperCaseFirst } from '../utils/strUtils';
// import { LessThanIcon } from './icons/LessThanIcon';
import { Title } from './Title';
import { ShadowButton }  from './buttons/ShadowButton';
import { DualModeButton }  from './buttons/DualModeButton';
import { prtStart, prtInput, prtMsg, prtVar, prtErr }   from  '../utils/prt';

const FNAME = "PicInvites.js"
const TRACE = true;

// JSX used to construct a row; If date is less that 8 characters means it string "Not Sent".
// If greater that 8 characters, its the ISODate. This formats it as short date.
const InviteRow = ({email, name, sentdate, isChecked, handler}) => {
  //TRACE && prtStart(FNAME, "InviteRow");

  //TRACE && prtInput("email", email);
  //TRACE && prtInput("name", name);
  //TRACE && prtInput("sentdate", sentdate);
  //TRACE && prtInput("isChecked", isChecked);

  return (
    <div className="invites-row">
        <div className="col01">
          <input  className="invites-row-checkbox"
              value={email}
              type="checkbox"
              checked={isChecked || false}
              onChange={handler}
          />
        </div>
        <div className="col02">{email}</div>
        <div className="col03">{name}</div>
        <div className="col04">{sentdate !== null ? format(sentdate, 'MM/dd/YY') : 'Not Sent' }</div>
    </div>
  );
}

// JSX used to construct checkbox at column heading (selects all)
const InviteCheckBoxHeader = ({checked, handler}) => {
  
  return (
    <div className="col01">
        <input  className="invites-header-checkbox"
            id="checkboxheader"                    
            value="yes"
            name="user1"
            type="checkbox"
            checked={checked}
            onChange={handler}
        />
    </div>
)};
  
  /*
    Parent Component: this component ;  renders autosuggest input bar and the particpant table list.
           It also provides sort capabilty for email and name.
           When a user clicks the Plus Icon on the input bar,  a few things happen: 
                - the entry is added to particant list in redux store (NOT IMPLEMENTED)
                - add New Particant Action is dispatched. This action adds participant 
                      to the particpant list for this event in mongodb and adds the participant
                      to user's contacts collection (if it does not already exist)  (NOT IMPLEMEMTED)
                - it clears the input field in the input bar
    Child  Component: PicContactsAutsuggest;  this provides two input fields with autosuggest capability
           It passes up the two input values (email and name) via a function prop (setParentComponentValues);
    inputs:  - (from redux store/mapStateToProps) list of existing participants, set at initialization time ; NOT IMPLEMENTED
             - (from function prop) emailValue and nameValue passed up from PicContactsAutosuggest component via the
               setParentComponentValues function prop.
             - (from mapDispatchToProps) clearPicAppError function, used to clear errors on store once resolved
    outputs: - render input bar containing autosuggest component for email and name 
  */
class PicInvites extends React.Component {

    

    constructor(props) {
      super(props);

      this.state = {
        // participants: participantList,      // this particants for an event. The check box status for individual rows is maintained in this array 
        // participants: [],      // this particants for an event. The check box status for individual rows is maintained in this array 
        checkAll: true,           // check box status for "Check All"
        emailValue: '',            // both emailValue and nameValue is set when a suggestion is selected
        nameValue: '',             // from either the email input field or name input field
        childFunction: '',         // Function provided by PicContactsAutosuggest to be able to clear input fields
        emailSortAsc:  true,
        nameSortAsc:   true,
        dateSortAsc:   true,
        dualButtonMode: 1,         // Send invites button flips to mode 2 which  is "Done", once invites have been sent succesfully
        formError: ''
      };
    }
    
    // ****************************************************************** */
    // Lifecycle Methods
    // ****************************************************************** */

    componentDidMount() {
      //TRACE && prtStart(FNAME, "componentDidMount")
      let participantEmail = this.props.auth.user.email;     
      let event_id  = this.props.event.active._id;
      let authToken = this.props.auth.token;

      getParticipants(participantEmail, event_id,  authToken).then((response) => {
        let participants = response.participants || [];
        let checkAll     = true;
        // Set checkmarks for participants whose invite has not been sent out. Also, 
        // if some invites have been sent out, then uncheck the CheckAll box.. 
        let updatedParticipants = participants.map(participant  => { 
          if (!participant.sentdate) {       /* participant has NO sentdate */
              participant.isChecked = true; 
          } else {                           /* participant has sentdate */
              participant.isChecked = false; 
              checkAll = false;       // If 
          }
          // if (participant.sentdate === null) {participant.sentdate = "Not Sent"};
          return participant
        })
        this.setState({checkAll})
        console.log(`Thiis response : ${JSON.stringify(participants,null,2)}`);
        this.props.updateParticipants(updatedParticipants);
      })
    }
    
    componentWillUnmount() {
      if (this.props.picapp.error) {
        this.props.clearPicAppError();
      }
    }
    
    // ****************************************************************** */
    // Specialty functions for componennt to component interaction 
    // ****************************************************************** */

    // This function is passed down to the PicContactsAutosuggest component. The PicContactsAutosuggest
    // component calls this function to pass up the email and name value that were set on the Autosuggest component.
    // This function will then set the values so we can render it on this page.
    setParentComponentValues = (emailValue, nameValue) => {
      this.setState({ emailValue, nameValue });
    };

    // This function is passed as a function prop to the PicContactsAutoSuggest child component, 
    // within the render function. The purpose of passing it down is for the PicContactsAutoSuggest 
    // component to let this parent component know what function to call when it needs to clear input fields.
    // The function provided will be saved in local state and called to clear the input field
    // everytime user adds a new participant (handleAddNewParticipant)
    getChildFunction = (childFunction) => {
      this.setState({childFunction})
    }

  
    // ****************************************************************** */
    // Handlers 
    // ****************************************************************** */
    handleCheckBoxAll = () => {

      this.revertButtonIfSendingAgain();   // see function for description
      
      let { list } = this.props.participants;

      this.setState((state) => {
          let checkAll = !state.checkAll        // toggle true/false state
          list.forEach(participant => { participant.isChecked = checkAll;}) // change on all 
          return {checkAll};
      })
    };

    handleCheckBoxSingle = (event) => {
      //TRACE && prtStart(FNAME, "handleCheckBoxSingle")

      this.revertButtonIfSendingAgain();   // see function for description

      let { list: participants }  = this.props.participants;

      // get index value for target email
      let targetEmail = event.target.value;

      // Set up a 


      // create a new participant list and assign the modified participant object
      let participantsCopy = [...participants];
      let indexFound = participantsCopy.findIndex((participant) => {return (participant.email === targetEmail)})
      let foundParticipant = participantsCopy[indexFound];
      // toggle check mark 
      foundParticipant.isChecked = !foundParticipant.isChecked;
      // update participant entry      
      participantsCopy[indexFound] = foundParticipant;

      // set the state using modified participant list
      // this.setState({participants: modifiedParticipantList})
      this.props.updateParticipants(participantsCopy) ;
    }

    /* This function is called by both checkbox handlers for the following reason:  If user clicked Send invites button. the button is flipped to Done. 
       If user decides to send another invite, before clicking "Done", the button should revert back to "Send Invites". This is what this 
       function is for */
    revertButtonIfSendingAgain = () => {
      //TRACE && prtStart(FNAME, "revertButtonIfSendingAgain")

      let { dualButtonMode } = this.state;

      if (dualButtonMode === 2) {
        this.setState({dualButtonMode: 1})
      }
    }

    // handleAddNewParticipant = () => {
      
    //   let { active: activeEvent } = this.props.event;
      
    //   /* If no event is active, let user know */
    //   if (isEmpty(activeEvent) ) {
    //      this.setState({formError: "Action required: select or create an event before adding participants:yes"});
    //      return;
    //   }
     
    //   if (this.isFormValidated()) {
    //       // /* split name and convert first characters to upper case */
    //       let fullname = this.state.nameValue.split(' ');        
    //       let firstName = upperCaseFirst(fullname[0]).trim();
    //       let lastName  = upperCaseFirst(fullname[1]).trim();  

    //       /* lets initialize flag, that tells us to add participant to contacts collection 
    //          based on whether participant already exist in the contacts collection */
    //       let addToContacts = this.existInContacts(this.state.emailValue) ? 'no' : 'yes';

    //       /* make copy of participants array*/
    //       let participantsCopy = []; 
    //       if (this.props.participants.list) {  
    //         participantsCopy = [...this.props.participants.list];
    //       } 

    //       /* add entry to the front of the array */
    //       participantsCopy.unshift({
    //         email: this.state.emailValue, 
    //         name:  firstName + ' ' + lastName,
    //         sentdate:  undefined,
    //       })
                    
    //       /* construct object needed to add participant to database */
    //       let newParticipant = 
    //       {
    //         organizerEmail: this.props.auth.user.email,
    //         event_id:   activeEvent._id,
    //         email: this.state.emailValue,
    //         name:  this.state.nameValue,
    //         addToContacts
    //       }

    //       /* in addition to passing object above to udpate database, pass participantsCopy
    //          so upon successful add of new partcipant, we update the redux store with new participant list.*/ 
    //       // this.props.startAddNewParticipant(newParticipant, participantsCopy);

    //       /* and clear local state values */
    //       this.setState({
    //         emailValue: '',
    //         nameValue: '',
    //         sentdate: ''
    //       })

    //       //clear both input fields in the child component (PicContactsAutoSuggest)
    //       this.state.childFunction('both');
    //   } else { 
    //     this.displayError(); 
    //   }
    // };

    // The way the delete works is it creates a new array with only the keepers (excludes the deletes).
    // It then replaces the entire array in the database with keepers list, if DB update is successful, 
    // it then replaces entire array in the local storage. Afterwards it clears picapp.error and 
    //  formError (if any), and clears checkAll flag (event that was selected)
    // handleDeleteParticipant = () => {
    //   /* create new array with only the keepers (excludes participant(s) deleted)  */
    //   let keepers       = this.props.participants.list.filter(participant => !participant.isChecked);
    //   let contactDeleteList    = this.props.participants.list
    //                            .filter(participant =>  participant.isChecked)
    //                            .map(participant =>  participant.email);
                                        

    //   /* if lengths are equal, nothing was deleted */
    //   if (keepers.length === this.props.participants.list.length) {
    //     this.setState({formError: "Letting you know: no selections were made; please select entries before clicking delete:yes"});
    //   } else {  /* one or more participants were selected */

    //     /* construct object used to delete participant(s) */
    //     let participantsDeleteObj = {
    //         event_id: this.props.event.active._id,
    //         organizerEmail: this.props.auth.user.email,
    //         participantList: keepers,
    //         contactDeleteList 
    //     }
    //     /* dispatch action to updateParticipants */
    //     this.props.startDeleteParticipants(participantsDeleteObj);
    //     // this.props.updateParticipants(keepers);
    //     /* if user previously tried to delete without a selection, a warning msg
    //      will display. This is good time to clear it. */
    //     this.setState({participants: keepers,
    //                    formError: '',
    //                    checkAll: false
    //              });
    //   }
    // }

    // This allows user to 'X' out message, after message pops up letting user know
    // they requested an action (eg delete, send mail) but did not select any participants.
    handleClearFormError = () => {
      this.setState({formError: ''})
    }

    // Send email invites:  upon successful completion, clear check flags, and update sentdate
    handleSendInvites = () => {
      let inviteList = [];

      /* (0) Check if we have participants, otherwise let user know to make selection first */
      if (!this.props.participants.list || this.props.participants.list.length === 0 ) {
        this.setState({formError: "Letting you know: You need to add someone before hitting send :yes" })
        return;
      } 
    
      /* (1a) create invites list based on whether user checked all or check some of the participants */
      this.state.checkAll ? inviteList = [...this.props.participants.list]
                          : inviteList = this.props.participants.list.filter(participant => participant.isChecked);

      if (inviteList.length === 0) {
        this.setState({formError: "Letting you know: no selections were made; please make selection before clicking Send:yes"});
        return;
      }

      /* (1b) Get organizer name for active event  */
      let organizer = this.getOrganizer();
      
     
      // (2) Send invites and update database with sentdates 

      /* 2a. Construct request object to sendinvites  */
      let sendInviteRequestObject = { 
          event_id: this.props.event.active._id,
          event_title: this.props.event.active.eventTitle,
          organizer,
          emails: inviteList.map(participantRow => participantRow.email)
      }
      console.log("This is event_title before sending invite ", sendInviteRequestObject.event_title);

      /* 2b. Set up api request to send invites*/
      let sendInviteRequest = new PicPostRequest("sendinvites")
          .setUserId(this.props.auth.user.email)
          .setRequestBody(sendInviteRequestObject)
          .setUri(`/sendinvite`)
          .setAuthToken(this.props.auth.token)
          .setLogTrace(true);

      /* 2c. Fire off the two chained api calls to send invites and update participant list with sent dates */
      sendInviteRequest.exec().then(() => {
           /* (3) clear check list and update the sent date */
          let updatedList = this.clearCheckList(this.props.participants.list);
          /* Construct Request Object to Update Participant list */
          let updateRequestObject = {
            event_id: this.props.event.active._id,
            organizerEmail: this.props.auth.user.email,
            participantList: updatedList
          }
          /* set up api request to update database with  */
          let updateParticipantListRequest = new PicPutRequest("UpdateParticipantList")
          .setUserId(this.props.auth.user.id)
          .setRequestBody(updateRequestObject)
          .setUri(`/event/participants`)
          .setAuthToken(this.props.auth.token)
          .setLogTrace(true);
          return  updateParticipantListRequest.exec()
      }).then((response) => {
          this.setState({dualButtonMode: 2})
      }).catch((error) => {
          let updateSentDate = false; /* don't update sentdate if we had failure */
          this.clearCheckList(this.props.participants.list, updateSentDate);
          this.setState({formError: "Server busy: may want to try again later"});
      });
    }    /* end of handleSendInvites */

    /* clearCheckList: Helper function used by handleSendInvites to clear the check marks and update 
       sentdate after email has been sent */
    clearCheckList = (theList, updateSentDate = true) => {
      let copyOfList = [...theList];
      // let sentDate = new Date().toISOString();
      let sentDate = new Date();
      // sentDate = format(sentDate, 'MM/dd/YY');
      if (updateSentDate) {
        copyOfList.forEach( (participant) => {
            if (participant.isChecked === true) {
                participant.isChecked = false;
                participant.sentdate = sentDate;
            } 
        })  
      }
      if (!updateSentDate) { 
          copyOfList.forEach( participant => participant.isChecked = false ) 
      }

      this.props.updateParticipants(copyOfList);          /* update state with new copy of array  */
      this.setState({checkAll: false});  /* clear the checkAll flag */
      return copyOfList;
    }


    handlePreviewInvite = () => {  
        let activeEvent = this.props.event.active._id;

        history.push(`/myinvitation/${activeEvent}`)
    }

    handleOnClickBackButton = (e) => {
        e.preventDefault();
        history.push("/eventmanage/lists");
    }

    handleOnClickDone = () => {
      history.push("/dashboard");
    }

    // ****************************************************************** */
    // Utility / Helper methods.
    // ****************************************************************** */

    getOrganizer = () => {
      /* construct full name */
      let full_name  = this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname;
      /* If there is no entity name specified, use the organizer's name */
      let organizer = this.props.event.active.organizer || full_name;
      return organizer;
    }

    isFormValidated = () => {
      let valid = false;
      if (!this.state.emailValue &&  !this.state.nameValue) {
          this.setState(() => ({ formError: 'Missing something: Please enter email and name:yes'}))
      } else 
      if (!this.state.emailValue && this.state.nameValue) {
          this.setState(() => ({ formError: 'Missing something: Please enter email:yes '}));
      } else 
      if (this.state.emailValue && !this.state.nameValue) {
            this.setState(() => ({ formError: 'Missing something: Please enter name:yes'}));
      } else 
      if (this.state.emailValue.length > 50) {
        this.setState(() => ({ formError: 'Too Many Characters: Sorry! you may only enter 50 characters in the email:yes'}));
      } else 
      if (this.state.nameValue.length > 32) {
          this.setState(() => ({ formError: 'Too Many Characters: Sorry! you may only enter 32 characters for the name:yes'}));
      } else 
      if (!isEmail(this.state.emailValue) ) {
              this.setState(() => ({ formError: 'Something wrong: email address is not properly formatted:yes'}));
      } else 
      if (this.isDuplicateParticipant() ) {
              this.setState(() => ({ formError: `Letting you know: '${this.state.emailValue}' has already been added:yes`}));
      } else 
      if (this.state.nameValue.trim() === '') {
          this.setState(
            { formError: 'Missing something: Please enter name:no ' },
            () => {this.displayError(); 
                  this.state.childFunction('name'); // clear name input field in child component
                }  
          )
      } else {
        this.setState(() => ({ formError: ''}));
        valid = true;
        return valid;
      }
    }
    
    /* used by isFormValid to avoid adding duplicates */
    isDuplicateParticipant = () => {
      let emailEntered = this.state.emailValue;
      if (!this.props.participants.list) return false;
      return this.props.participants.list.find(function(participant) {
                return  participant.email === emailEntered
             })
    };
    
    /* used by handleAddNewParticipant , to see if participant already in contacts */
    existInContacts(email) {
      let contacts = this.props.contacts.list;
      function emailMatches(contact) {
          return contact.email === email;
      }
      let index = contacts.findIndex(emailMatches)
      return index > -1 ? true : false;
    }

    /* primary sort function */
    sortBy = (key) => {
      /* flip sort order flag (on local state) for key being used for sort */
      
      if (key === 'email') {
        this.setState(
          {emailSortAsc: !this.state.emailSortAsc},
          () => {sort()}
        )
      } else
      if (key === 'name')  {
        this.setState(
          {nameSortAsc: !this.state.nameSortAsc},
          () => {sort()}
        )
      } else 
      if (key === 'sortabledate') {
        this.setState(
          {dateSortAsc: !this.state.dateSortAsc},
          () => {sort()}
        )
      }

      let sort = () => {
        let arrayCopy = [...this.props.participants.list];
        arrayCopy.sort(this.compareBy(key));
        // this.setState({participants: arrayCopy});
        this.props.updateParticipants(arrayCopy);
      }
    } 
    
    // SortBy support function
    // inputs: function parameters: possible key values are: email, name, or sentdate
    //         local state: this function uses the emailSortAsc flag to check whether sort is Asc, if not,
    //                      it sorts in descending order. 
    compareBy = (key) => {
      // console.log(`>>> COMPAREBY  key value is "${key}"`);
      let sortAsc = '';
      if (key === 'email') {
        sortAsc = this.state.emailSortAsc;
        // console.log(`     key value was email`)
      } 
      if (key === 'name') {
        sortAsc = this.state.nameSortAsc;
        // console.log(`     key value was name`)
      }
      if (key === 'sortabledate') {
        sortAsc = this.state.dateSortAsc;
        // console.log(`     key value was sentdate`)
      }
      

      /* sort ascending or descending based on current sort order flag */
      if ((key === 'email' || key === 'name') && (sortAsc === true)) {
        // console.log(`    currently sorting ASCENDING`);
        return function (a, b) {
            if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
            if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
          return 0;
        };
      } else 
      if ((key === 'email' || key === 'name') && (sortAsc === false)) {
        // console.log(`    currently sorting DESCENDING`);
        return function (a, b) {
            if (a[key].toLowerCase() > b[key].toLowerCase()) return -1;
            if (a[key].toLowerCase() < b[key].toLowerCase()) return 1;
        }
      } else if ((key === 'sortabledate')  && (sortAsc === true)) {
        // console.log(`    sorting date ASCENDING`);
        return function (a, b) {
          return a.sortabledate - b.sortabledate;
        }
      } else if ((key === 'sortabledate')  && (sortAsc === false)) {
        // console.log(`    sorting date DESCENDING`);
        return function (a, b) {
          return b.sortabledate - a.sortabledate ;
        }
      } else { /* do nothing */}
    }
   

    displayError = (withCloseOption) => {
        let error = this.state.formError || this.props.picapp.error || '';

        if (error) {
            // Split message
            let messageArray = error.split(':');
            let [ messageLabel, message, closeoption ] =  messageArray;
            // Return message JSX
            return  <div className="invites-pic-error ">
                      <div>
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle} />
                        <span className="pic-err-msg-label">{`${messageLabel}: `}</span>
                        <span className="pic-err-msg">{message}</span>
                      </div>
                      {closeoption === 'yes' && <div className="error-close" onClick={this.handleClearFormError}>X</div>}
                    </div>
        } else {
            return <p className="pic-error-filler">&nbsp;</p>
        }
    }

    haveInvitesBeenSent = () => {
      let participants = this.props.particpants;
      
    }

    // ****************************************************************** */
    // render method
    // ****************************************************************** */ 
    render() {

      // Initialize event title; If no event is selected, do not show the literal "for" or a title.
      let  eventTitle = "Invitees";
      
      // If there is an active event, concat 
      let { active: activeEvent  } = this.props.event;
      if (!isEmpty(activeEvent)) {
          eventTitle   = eventTitle + " for " + activeEvent.eventTitle;
      }
      // If there are participants for that selected event, set participants, otherwise set to empty array
      let participants = [];
      if (this.props.participants) { 
         participants  = this.props.participants.list;  
      }

      const rows = participants.map( (rowData) => {
        return  ( <InviteRow {...rowData} handler={this.handleCheckBoxSingle} key={rowData.email} /> )
      });

      return (
        <div className="tab-selection-panel">
          <div className="invites-table-container">
              <div className="invites-error-container" >
              {this.displayError()} 
              </div>
              <Title text={eventTitle} />
              {/*
              <div className="invites-delete-button"
                   onClick={this.handleDeleteParticipant}
              >    Delete 
              </div> */}
              <div>
                <div className="invites-header-text">
                  Note, after sending invites, you may come back and selectively add/send invites to additional people.
                </div>
                <div className="invites-input-row">
                    <div className="invites-header-text">
                    
                    </div>
                    {/*
                    <div className="col02-03">
                        <PicContactsAutoSuggest  
                            setParentComponentValues={this.setParentComponentValues} 
                            getChildFunction={this.getChildFunction} 
                        />
                    </div>
                    <button onClick={this.handleAddNewParticipant} className="tiny-plus-button" >
                        <div className="tiny-plus-icon">+</div>
                    </button>
                    */}
                </div>
              </div>
                <div className="invites-header">
                    <InviteCheckBoxHeader 
                        checked={this.state.checkAll} 
                        handler={this.handleCheckBoxAll}
                    />
                    <div className="col02" onClick={() => this.sortBy('email')} >Email Address</div>
                    <div className="col03" onClick={() => this.sortBy('name')}>Name</div>
                    <div className="col04" onClick={() => this.sortBy('sortabledate')}>Date Sent</div>
                </div> 
              
              <div className="invites-table">
                {participants.length === 0 ? (
                  <div>
                    <p className="invites-noparticipants-msg1"></p>
                    <p className="invites-noparticipants-msg2"></p>
                  </div>
                ) : (
                  <div>
                    {rows}
                  </div>
                )}
              </div>
              <hr className="line-separator" />
              <div className="invite-buttons-container">
                  <div className="eventinfo-back-button-container">
                    <ShadowButton  buttonText="Back" words={1} onClickHandler={this.handleOnClickBackButton} />
                    <div className='eventinfo-modifier-plr1'>
                        <div onClick={ () => { history.push("/dashboard")} }><HomeIcon /></div>
                    </div>
                  </div>
                  <div className="invite-right-buttons-container">
                    <button onClick={this.handlePreviewInvite} className="preview-invite-button">Preview Invite</button>
                    <div>&nbsp;</div>
                    <DualModeButton mode={this.state.dualButtonMode} button1Text="Send Invites" onClickHandler1={this.handleSendInvites}
                                    words={2} color2="green"         button2Text="Done"         onClickHandler2={this.handleOnClickDone} />
                  </div>
              </div>
              <div className="show-for-mobile rc-horiz-spacer-tiny-minus">&nbsp;</div>
          </div>
      </div>
      );
    }
} /* Component (PicInvites) end */ 
  

const mapStateToProps = (state) => {
    return {
        auth:   state.auth,
        picapp: state.picapp,
        event:  state.event,
        participants:  state.participants,
        contacts: state.contacts
    };
};

const mapDispatchToProps = (dispatch) => ({
    clearPicAppError:       () => dispatch(clearPicAppError()),
    // startGetParticipants:   (fromPage) => dispatch(startGetParticipants(fromPage)),
    startAddNewParticipant: (newParticipant, participantsCopy) => dispatch(startAddNewParticipant(newParticipant, participantsCopy)),
    startDeleteParticipants: (participantsArray) => dispatch(startDeleteParticipants(participantsArray)),
    updateParticipants:     (participants) => dispatch(updateParticipants(participants))
});

export default connect(mapStateToProps, mapDispatchToProps)(PicInvites);



// WEBPACK FOOTER //
// ./src/components/PicInvites.js